import { Link } from "react-router-dom";

import { SectionCard } from "@/shared/ui/SectionCard";

export function NotFoundPage() {
  return (
    <div className="page-stack">
      <SectionCard
        eyebrow="404"
        title="The path you opened is outside the current CatieChess command map."
        className="not-found-panel"
      >
        <p>
          Return to the homepage or re-enter through the product routes that are
          already staged: play, analysis, games, community, and public dossiers.
        </p>
        <div className="button-row">
          <Link className="button-link button-link--primary" to="/">
            Back home
          </Link>
        </div>
      </SectionCard>
    </div>
  );
}
